import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useResourceVoucherProduct = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getAllResourceVoucherProducts = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: '/api/v1/resourceVoucherProduct',
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
        });
        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const createResourceVoucherProduct = async body => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: '/api/v1/resourceVoucherProduct',
          method: 'POST',
          headers: authCtx.getAuthHeaders(),
          body,
        });
        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const updateResourceVoucherProduct = async (id, body) => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/resourceVoucherProduct/${id}`,
          method: 'PATCH',
          headers: authCtx.getAuthHeaders(),
          body,
        });
        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const deleteResourceVoucherProduct = async id => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/resourceVoucherProduct/${id}`,
          method: 'DELETE',
          headers: authCtx.getAuthHeaders(),
        });
        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  // RVP Availability management
  const getAllRvpAvailabilities = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: '/api/v1/rvpAvailability',
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
        });
        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const createRvpAvailability = async body => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: '/api/v1/rvpAvailability',
          method: 'POST',
          headers: authCtx.getAuthHeaders(),
          body,
        });
        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const updateRvpAvailability = async (availabilityId, body) => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/rvpAvailability/${availabilityId}`,
          method: 'PATCH',
          headers: authCtx.getAuthHeaders(),
          body,
        });
        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const deleteRvpAvailability = async availabilityId => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/rvpAvailability/${availabilityId}`,
          method: 'DELETE',
          headers: authCtx.getAuthHeaders(),
        });
        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  return {
    isLoading,
    error,
    getAllResourceVoucherProducts,
    createResourceVoucherProduct,
    updateResourceVoucherProduct,
    deleteResourceVoucherProduct,
    getAllRvpAvailabilities,
    createRvpAvailability,
    updateRvpAvailability,
    deleteRvpAvailability,
  };
};

export default useResourceVoucherProduct;
